import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { useFecImportSession, type UseFecImportSessionResult } from '../hooks/useFecImportSession'

const FecImportSessionContext = createContext<UseFecImportSessionResult | undefined>(undefined)

interface FecImportSessionContextProviderProps {
  children?: ReactNode
}

export const FecImportSessionContextProvider = ({ children }: FecImportSessionContextProviderProps): ReactElement => {
  const session = useFecImportSession()

  return <FecImportSessionContext.Provider value={session}>{children}</FecImportSessionContext.Provider>
}

interface FecImportSessionContextValueProviderProps {
  children?: ReactNode
  value: UseFecImportSessionResult
}

/** Test-only: inject a session value without running `useFecImportSession`. */
export const FecImportSessionContextValueProvider = ({
  children,
  value,
}: FecImportSessionContextValueProviderProps): ReactElement => (
  <FecImportSessionContext.Provider value={value}>{children}</FecImportSessionContext.Provider>
)

export const useFecImportSessionContext = (): UseFecImportSessionResult => {
  const context = useContext(FecImportSessionContext)

  if (!context) {
    throw new Error('FecImportSessionContextProvider is missing in the module!')
  }

  return context
}
